import { useCallback, useState } from 'react'

import { useBlock, useSlate } from '@tribeplatform/react-slate-kit/hooks'

import { useQueryParam } from '../../common/hooks/useQueryParam.js'
import { View } from '../types.js'

const encodeViewName = (view: View) => view.name.toLowerCase().trim()
interface Props {
  views: View[]
}

export const useMultiViewBlockQueryParam = ({ views }: Props) => {
  const { block } = useBlock()
  const { mode } = useSlate()
  const preview = mode !== 'live'

  const blockName = block.extraProps.displayName ?? block.name

  const [viewParam, setParam] = useQueryParam(
    { name: blockName, property: 'view' },
    {
      navigationMode: 'replace',
    },
  )

  const [selectedIndex, setSelectedIndex] = useState(() => {
    const index = views?.findIndex(view => {
      return encodeViewName(view) === viewParam
    })
    return index < 0 ? 0 : index
  })

  const setIndex = useCallback(
    (newIndex: number) => {
      if (!preview) {
        if (newIndex === 0) {
          setParam(undefined)
        } else {
          setParam(encodeViewName(views?.[newIndex]))
        }
      }
      setSelectedIndex(newIndex)
    },
    [preview, setParam, views],
  )
  return [selectedIndex, setIndex] as const
}
